// extracted by mini-css-extract-plugin
export default {"title":"section-title-vertical-module--title--bZzr1"};